angular.module('TetherApp').controller('TaskController', [
    '$http',
    function ($http) {
        let self = this;
        this.clientEid = '';
        this.task = {
            date_selection: 'now',
            date: new Date(),
            hour: '',
            minute: '',
            timezone: ''
        };
        this.search = '';
        this.people = [];
        this.person = {};
        this.send_to_myself = 1;
        this.searchu = '';
        this.users = [];
        this.user = {};

        this.searchPeople = function () {
            $http.get('/api/client-participant', {
                cache: false,
                headers: { 'Cache-Control' : 'no-cache' },
                params: { client: this.clientEid, search: this.search }
            }).then(this.displaySearchPeopleResults);
        };

        this.displaySearchPeopleResults = function (response) { self.people = response.data.data; };

        this.debouncedSearchPeople = _.debounce(this.searchPeople, 250, { 'maxWait': 1000 });

        this.updatePerson = function (person) { this.person = person; this.search = ''; this.people = []; };

        this.personIdentifier = function () {
            if (this.person.name) {
                return this.person.name;
            }
            if (this.person.email) {
                return this.person.email;
            }
            if (this.person.phone) {
                return this.person.phone;
            }
            return '';
        };

        this.searchUser = function () {
            $http.get('/api/user', {
                cache: false,
                headers: { 'Cache-Control' : 'no-cache' },
                params: { client: this.clientEid, search: this.searchu }
            }).then(this.displaySearchUserResults);
        };

        this.displaySearchUserResults = function (response) { self.users = response.data.data; };

        this.debouncedSearchUser = _.debounce(this.searchUser, 250, { 'maxWait': 1000 });

        this.updateUser = function (user) { this.user = user; this.searchu = ''; this.users = []; };

        this.userIdentifier = function () {
            if (this.user.name) {
                return this.user.name;
            }
            if (this.user.email) {
                return this.user.email;
            }
            if (this.user.phone) {
                return this.user.phone;
            }
            return '';
        };

        this.initDate = function (taskDate) {
            if (taskDate) {
                this.task.date = new Date(taskDate);
            } else {
                this.task.date = new Date();
            }
        };

        this.initPerson = function (personEid) {
            if (personEid) {
                $http.get('/api/client-participant', {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' },
                    params: { client: this.clientEid, search: personEid }
                }).then(function (response) {
                    self.person = response.data.data[0];
                });
            }
        };

        this.dateSelectionChange = function () {
            if (this.task.date_selection !== 'custom') {
                let dayDiff = 0;
                if (this.task.date_selection === 'tomorrow') {
                    dayDiff = 1;
                }
                if (this.task.date_selection === '7_days') {
                    dayDiff = 7;
                }
                if (this.task.date_selection === '28_days') {
                    dayDiff = 28;
                }
                let nowDate = new Date();
                this.task.date = new Date(nowDate.getFullYear(), nowDate.getMonth(), (nowDate.getDate() + dayDiff), 0, 0, 0, 0);
            }
        };

        this.completeTask = function (taskEid) {
            if (window.confirm('Are you sure you want to mark task "' + taskEid + '" as completed?')) {
                $http.post('/tasks-completed/' + taskEid, { client: this.clientEid }, {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                }).then(function () {
                    window.location = window.location;
                });
            }
        };

        this.deleteTask = function (taskEid) {
            if (taskEid && window.confirm('Are you sure you want to delete task "' + taskEid + '"?')) {
                $http.delete('/tasks/' + taskEid, {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' },
                    params: { client: this.clientEid }
                }).then(function () {
                    window.location = window.location;
                });
            }
        };
    }
]);
